import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 10px;
    padding: 16px 20px;
    min-height: 96px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Title = styled.h2`
    margin: 0;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const Subtitle = styled.p`
    margin: 4px 0 0 0;
    font-family: Lato;
    font-size: 11px;
    color: ${theme.colors.gray.Cinza_1};
`;

export const ValueRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-top: 6px;

    @media only screen and (min-width: 770px) and (max-width: 1024px) {
        flex-direction: ${props => props.stackTrend ? 'column' : 'row'};
        align-items: ${props => props.stackTrend ? 'flex-start' : 'flex-end'};
    }
`;

export const Value = styled.p`
    margin: 0;
    font-family: Lato;
    font-size: 32px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_1};
    line-height: 1.1;
    white-space: nowrap;
`;

export const LoadingBox = styled.div`
    width: 100%;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Trend = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;

    .arrow {
        font-size: 10px;
        color: ${props => props.positive ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
    }

    .percent {
        font-family: Lato;
        font-size: 12px;
        font-weight: 700;
        color: ${props => props.positive ? theme.colors.green.Verde_AgroReceita : theme.colors.red.Vermelho_erro};
    }

    .label {
        font-family: Lato;
        font-size: 12px;
        color: ${theme.colors.gray.Cinza_7};
    }
`;
